import React from 'react';
import JobInfoCard from '../components/JobInfoCard';
import NavBar from '../components/navbar';
import SideBarEmployer from '../components/SideBarEmployer';
import CustomBtn from '../components/CustomBtn';
import { IconButton, Typography, Divider } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react';

const useStyles = theme => ({

  verticalContainer: {
    display: 'flex',
    flexDirection: "row",
    padding: '30px 50px',
  },
  verticalContainerTwo: {
    display: 'flex',
    flexDirection: "row",
    justifyContent: 'space-between',
    flexGrow: '1'
  },
  sideContainer: {
    display: 'flex',

  },
  divide: {
    '& .MuiDivider-root': {
      border: '1.5px solid #EA8833',
      borderRadius: '2px',
      width: '65px',
      backgroundColor: '#EA8833',
      opacity: 1

    },
    marginLeft: '10px',
    marginBottom: '20px'
  },
  title: {
    fontSize: '24px',
    fontFamily: ['Nunito'].join(','),
    marginLeft: '10px',
    marginBottom: '25px',
    color: '#4F5052'
  },
  subTitle: {
    fontFamily: ['Nunito'].join(','),
    marginLeft: '10px',
    color: 'black'
  },
  subTitleBlue: {
    color: '#153BAB',
    fontFamily: ['Nunito', 'sans-serif'].join(','),
    fontSize: '24px',
    marginTop: '-30px',
    marginLeft: '-50px'
  },
  iconBtn:{
    '& .MuiSvgIcon-root':{
      color:'#153BAB',
    },
  },
  icon:{
    height:'35px',
    width:'35px',
  }


});

const BusinessProfile = (props) => {

  const { classes } = props;
  console.log(props.location.state)
  const { user } = useAuth0();
  // loading and error is not used 
  // const [loading, setLoading] = React.useState(true);
  // const [error, setError] = React.useState('');
  const [data, setData] = React.useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect( () => {
    // setLoading(true);
     fetch(process.env.REACT_APP_IP + '/employer/data/' + user.sub)
      .then((response) => response.json())
      .then((data) => {
        // setLoading(false);
        setData(data);
      })
      .catch((e) => {
        // setLoading(false);
        // setError('fetch failed');
        console.log("fetch failed")
      });

      fetch(process.env.REACT_APP_IP + '/projects/datalist',{
        method: "post",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        //make sure to serialize your JSON body
        body: JSON.stringify({
          id: user.sub
        })
      })
      // user.sub
      .then((response) => response.json())
      .then((data) => {
        console.log(data)
      })
      .catch((e) => {
        console.log(e)
      });


  }, [user]);

  return (
    <div className={classes.root}>
      <NavBar type="main" />
      <div className={classes.verticalContainer}>
        <div className={classes.sideContainer}>
          {data.employer && data.employer.state ? <SideBarEmployer query={data.employer.state} /> : null}
        </div>


        <div >
          <br />
          <br />
          <br />
          <Typography className={classes.subTitleBlue}>
          <IconButton className={classes.iconBtn}><ArrowBackIcon className={classes.icon}/></IconButton>
            <strong>Business Profile</strong></Typography>
          <div className={classes.verticalContainerTwo}>
            <Typography className={classes.subTitle} variant='body2'><strong>Partner Info</strong></Typography>
          </div>
          <div className={classes.divide}>
            <Divider />
          </div>
          <JobInfoCard Location={data.employer && data.employer.state && data.employer.state.title}
            level={data.employer && data.employer.state && data.employer.state.company}
            job={data.employer && data.employer.state && data.employer.state.interest}
            Elevel={data.employer && data.employer.state && data.employer.state.phone} />
          {/* <JobOverviewCard Overview={props.Overview} Qualifications={props.Qualifications}/> */}
          <br/>
          <br/>
          <br/>
          <Link   to={{ pathname: "scope",   }} >
          <CustomBtn width="25%" colorwhite={false} txt="Add a project" />
        </Link>
        </div>



      </div>
      <br />

      <center>

      <div className={classes.verticalContainerTwo}>
        <Typography className={classes.subTitle} variant='body2'><strong>Project Info</strong></Typography>
      </div>
      </center>
      <br />
      <br />
    </div>

  );
}

export default withStyles(useStyles)(BusinessProfile);
